export const iconFontAwesomeSecurityHandsHoldingChild = (
	<i className="fa-solid fa-hands-holding-child"></i>
);
